import { z } from 'zod';

import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    requiredNumber,
    requiredUuid,
} from './fields';
import { SYNC_UPDATE_VALIDATION_SCHEMA } from './common';

export const createEntryProductsAddSchema = () =>
    z.object({
        id: requiredUuid(),
        created_at: requiredNumber(),
        updated_at: requiredNumber(),
        entry_id: requiredUuid(),
        product_id: requiredUuid(),
        quantity: requiredNumber().min(1),
        user_id: requiredUuid(),
        organisation_id: requiredUuid(),
    });

export const createEntryProductsUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createEntryProductsAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.entry_products,
    );

export const createEntryProductsDeleteSchema = () => createDeleteSchema();

export const createEntryProductsSchemas = () => ({
    add: createEntryProductsAddSchema(),
    update: createEntryProductsUpdateSchema(),
    delete: createEntryProductsDeleteSchema(),
});
